import React from 'react'

interface IWithGrayLabelProps {
  label: string
  nothingIfabsent?: boolean
  absecePlaceholder?: string
}

const WithGrayLabel: React.FC<IWithGrayLabelProps> = ({
  label,
  nothingIfabsent,
  absecePlaceholder,
  children,
}) => {
  return (
    <>
      {nothingIfabsent && !children ? (
        <></>
      ) : (
        <div style={{ display: 'flex', columnGap: '20px' }} className='py-1'>
          <span className='grey pr-3 d-flex align-items-center'>{label}</span>
          {/* <div className='py-2'>{children || absecePlaceholder}</div> */}
          <>{children || absecePlaceholder}</>
        </div>
      )}
    </>
  )
}
export default WithGrayLabel
